// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { ProcedureActionConfigurationObjects_abstract } from './../abstract/SagaSchema/ProcedureActionConfigurationObjects_abstract';
export class ProcedureActionConfigurationObjects extends ProcedureActionConfigurationObjects_abstract {}
